var map = {
	"./CRH.svg": "COEg",
	"./Douterloigne.svg": "21b7",
	"./Douterloigne_icon.svg": "kiCd",
	"./Echo.svg": "EH1n",
	"./Echo_icon.svg": "reQO",
	"./Ergon.svg": "n+X8",
	"./Ergon_icon.svg": "Agbn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g9z3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vectors/logos ^\.\/.*$
// module id = g9z3
// module chunks = 21